import axios from "axios"
import global from "../../../globalvar";

let state = {
    lotLogList: []
};
let getters = {};
let mutations = {
    setLotLogList(state, lotLogList) {
        state.lotLogList = lotLogList.map(lot => ({
            desiredAlcohol: null,
            desiredReadyDate: null,
            alcholTollerance: 0.5,
            ...lot
        }))
    }
};
let actions = {
    async loadLotLogs({commit, dispatch, rootState}) {
        console.log(rootState);
        try {
            commit("appModule/startFetching", null, { root: true });
            let lotLogList = (await axios.get(global.ApiBaseUrl +"/api/lotlog/all", {
                headers: {
                    "x-auth-token": JSON.parse(localStorage.getItem("authInfo")).token
                }
            })).data;
            commit("appModule/endFetching", null, { root: true })
            commit("setLotLogList", lotLogList)
        } catch (e) {
            dispatch("appModule/addErrorMessage", e, { root: true } )
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
